const isArray = (value) => {
  return value && value.constructor === Array;
};

export default isArray;



// WEBPACK FOOTER //
// ./src/core/utils/isArray.js